import { render, staticRenderFns } from "./DocumentationCompleteIcon.vue?vue&type=template&id=fa5c6968"
import script from "./DocumentationCompleteIcon.vue?vue&type=script&lang=js"
export * from "./DocumentationCompleteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports